var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"fly-loading",class:{'fly-loading--visible': _vm.visible}},[_c('div',{staticClass:"fly-loading__inner"},[_c('i'),_vm._v("\n       \n      "),_c('span',[_vm._v(_vm._s(_vm.text || 'Loading...'))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dddd5fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./common/components/loading.vue
// module id = null
// module chunks = 